import { FC, ReactNode, useCallback } from 'react'
import cn from './index.module.css'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import { Select } from 'antd'
import classNames from 'classnames'

interface ISelectField {
  label?: string
  value?: string[] | string | null
  defaultValue?: string[] | string | null
  mode?: 'multiple' | 'tags'
  placeholder?: string
  notFoundContent?: ReactNode
  isInvalid?: boolean
  options: Array<{ label: string; value: string }>
  className?: string
  wrapperClassName?: string
  popupClassName?: string
  disabled?: boolean
  loading?: boolean
  onChange: (value: string[] | string | null) => void
  onSearch?: (value: string) => void
}

const SelectField: FC<ISelectField> = ({
  label,
  value,
  mode = undefined,
  defaultValue = null,
  placeholder,
  notFoundContent,
  options,
  isInvalid,
  className,
  wrapperClassName,
  popupClassName,
  disabled,
  loading,
  onChange,
  onSearch,
}) => {
  const filter = useCallback(
    (
      input: string,
      option:
        | {
            label: string
            value: number
          }
        | undefined,
    ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    [],
  )

  return (
    <FieldWrapper
      label={label}
      isInvalid={isInvalid}
      className={wrapperClassName}
    >
      <Select
        className={classNames(
          mode === 'multiple' ? cn.selectMultiple : cn.select,
          isInvalid && cn.invalid,
          className,
        )}
        loading={loading}
        disabled={disabled}
        defaultValue={defaultValue}
        value={value ?? null}
        placeholder={placeholder}
        onChange={(e) => onChange(e === undefined ? null : e)}
        //@ts-ignore
        options={options}
        mode={mode}
        showSearch
        allowClear
        notFoundContent={notFoundContent}
        filterOption={filter}
        popupClassName={classNames(cn.selectPopup, popupClassName)}
        onSearch={onSearch}
        // filterSort={sort}
      />
    </FieldWrapper>
  )
}

export default SelectField
